<template>
	<div class="erCodeWarp">
		<div class="txt">
			手机扫码访问
		</div>
		<div class="code">
			<img :src="images.code"/>
		</div>
	</div>
</template>

<script>
	var img = {};
	img.code = require('../assets/images/ercode.png');
	
	export default {
		data() {
		    return {
		    	images:img,
		    }
		},
	  	methods: {
	  	},
	}
</script>

<style lang="less" scoped>
	.erCodeWarp{
		position: absolute;
		right: -220PX;
		top: 20PX;
		width: 130PX;
		padding: 20PX 25PX;
		background-color: #fff;
		
		.txt{
			text-align: center;
			color: #666;
			font-size: 14PX;
			margin-bottom: 20PX;
		}
		
		.code{
			width: 130PX;
			height: 130PX;
			
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/ercode.vue